import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { API_CONFIG, FEATURE_FLAGS } from '../config/app.config';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(API_CONFIG.timeout),
      catchError((error) => {
        if (error instanceof TimeoutError) {
          if (FEATURE_FLAGS.enableErrorLogging) {
            console.error('[TimeoutInterceptor] Request timeout', {
              url: req.url,
              timeout: API_CONFIG.timeout,
            });
          }
          return throwError(() => new Error(`Request timeout: ${req.url}`));
        }
        return throwError(() => error);
      })
    );
  }
}
